import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';
import { JsaStats } from '../state-man/models/jsa-stats.model';

@Injectable({
  providedIn: 'root'
})

export class JsaStatsService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
    ) {
  }

  public async getStats () : Promise<JsaStats[] | null> {   
    try {      
      const ret = await this.apiService.apiReturnsAny('get', 'jsa/stats/')        
      return (ret && Array.isArray(ret)) ? JsaStats.buildMany(ret) : null      
    } catch (error) {
      LoggerService.log(error + 'jsa/stats/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')    
      return null
    }    
  }

}
